import { addProduct } from "../../redux/cartSlice";
import { useDispatch } from "react-redux";
import { PictureOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";

const ProductItem = ({ item, onEdit, onDelete }) => {
  const dispatch = useDispatch();
  const [imgError, setImgError] = useState(false);

  // Safety check: don't render if item is invalid
  if (!item || !item._id) {
    return null;
  }

  const handleClick = () => {
    dispatch(addProduct({ ...item, quantity: 1, key: item._id }));
  };

  const showPlaceholder = !item.img || imgError;

  return (
    <div
      className="rounded-lg product-item relative border cursor-pointer select-none
                 transition-all duration-300 hover:shadow-xl
                 group overflow-hidden bg-[#fff]"
      onClick={handleClick}
    >
      {/* Top‑right action icons (edit / delete) */}
      <div
        className="absolute top-1 right-1 z-10 flex items-center gap-1
                   bg-white/80 rounded-md px-1 py-0.5 shadow-sm
                   opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={(e) => e.stopPropagation()}
      >
        {onEdit && (
          <button
            type="button"
            className="text-gray-600 hover:text-blue-600 p-1 leading-none text-sm"
            onClick={() => onEdit(item)}
          >
            <EditOutlined />
          </button>
        )}
        {onDelete && (
          <button
            type="button"
            className="text-gray-600 hover:text-red-600 p-1 leading-none text-sm"
            onClick={() => onDelete(item)}
          >
            <DeleteOutlined />
          </button>
        )}
      </div>

      <div className="product-image h-28 overflow-hidden border-b flex items-center justify-center bg-gray-50">
        {showPlaceholder ? (
          <PictureOutlined className="text-2xl text-gray-400" />
        ) : (
          <img
            src={item.img}
            alt={item.title}
            onError={() => setImgError(true)}
            className="h-full w-full object-cover
                       transition-transform duration-500 ease-out
                       group-hover:scale-105"
          />
        )}
      </div>

      <div className="product-info flex flex-col p-3 items-center text-center gap-1">
        <span className="text-sm font-medium leading-tight text-gray-800">
          {item.title || "Untitled"} {item.mg > 0 ? `${item.mg} mg` : ""}
        </span>
        <span className="text-xs text-gray-600">Price: {(item.price || 0).toFixed(2)}</span>
        { item.unit > 1 && <span className="text-xs text-gray-500">Unit Price: {(item.price/item.unit || 0).toFixed(2)}</span> }
        {/* <span>Total Stock: {item.totalStock ?? "N/A"}</span> */}
      </div>
    </div>
  );
};

export default ProductItem;
